import styled from 'styled-components';

const Text = styled.p`
  margin: 0;
  font-family: BrandonText-Medium, Lato, sans-serif;
  color: ${(props) => props.color || 'black'};
  font-size: ${(props) => props.fontSize || '1rem'};
`;

const BoldText = styled(Text)`
  font-family: BrandonText-Bold, Lato, sans-serif;
`;

const BlackText = styled(Text)`
  font-family: BrandonText-Black, Lato, sans-serif;
`;

const RegularText = styled(Text)`
  font-family: BrandonText-Regular, Lato, sans-serif;
`;

const ButtonText = styled(BoldText)`
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  color: white;
  text-align: center;
`;

const SubscriptionText = styled(ButtonText)`
  background-image: linear-gradient(to left, #ffa14f, #db4c6d);
  background-clip: text;
  -webkit-background-clip: text;
  text-fill-color: transparent;
  -webkit-text-fill-color: transparent;
  text-align: center;
`;

const LinkText = styled(BoldText)`
  display: inline-block;
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  color: #8852cc;
`;

const TextInput = styled.input`
  font-family: BrandonText-Medium, Lato, sans-serif;
  border: none;
`;

export {
  Text,
  BoldText,
  ButtonText,
  TextInput,
  BlackText,
  LinkText,
  RegularText,
  SubscriptionText,
};
